main {
    @include flex-col(flex-start, stretch);
    flex-grow: 1;
    box-shadow: 0 3px 16px rgba(0, 0, 0, .15);
    border-radius: 8px;

    & > header {
        @include flex-row(space-between, center);
        padding: 4px 8px;
        background: #323132;
        color: #a0a0a0;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        user-select: none;
        border-radius: 8px 8px 0 0;
    }

    & > section {
        background: rgba(0, 0, 0, .5);
        backdrop-filter: blur(8px) grayscale(0.5);
        border-radius: 0 0 8px 8px;
        border: 1px solid #323132;
    }

    &.collapsed {
        & > header {
            border-radius: 8px;
        }

        & > section {
            display: none;
        }
    }
}
